import {
  AdminUiContentGroup,
  AdminUiMenuItem,
  AdminUiMenuItemActionIconType,
  AdminUiMenuItemType,
  AdminUiPage,
  AdminUiSubMenuItem,
  ProfileType,
} from '../../domain/admin-ui-details';
import { AdminUiMenuItemsApiModel } from '@cxb/editor-stb-api/model/adminUiMenuItemsApiModel';

export const mapAdminUiMenuItemsApiToDomain = (menuItems: AdminUiMenuItemsApiModel[]): AdminUiMenuItem[] =>
  menuItems.map((apiMenuItem) => ({
    name: apiMenuItem.name,
    url: apiMenuItem.url,
    order: apiMenuItem.order,
    defaultPlatformId: apiMenuItem.defaultPlatformId,
    actions: {
      isPlatformEnabled: apiMenuItem?.actions?.isPlatformEnabled,
      isMenuTypeEnabled: apiMenuItem?.actions?.isMenuTypeEnabled,
      iconType: apiMenuItem?.actions?.iconType as string as AdminUiMenuItemActionIconType,
    },
    type: apiMenuItem.type as string as AdminUiMenuItemType,
    defaultProfileType: apiMenuItem.defaultProfileType as string as ProfileType,
    availableProfileTypes: apiMenuItem.availableProfileTypes as unknown as Array<ProfileType>,
    pageTypes: apiMenuItem.pageTypes as unknown as Array<AdminUiPage>,
    subMenuItems: apiMenuItem.subMenuItems as unknown as Array<AdminUiSubMenuItem>,
    contentGroupTypes: apiMenuItem.contentGroupTypes as unknown as Array<AdminUiContentGroup>,
  }));
